/* assets/lp-nouveautes.js : page Nouveautés silumen.com (section lp-nouveautes).
   Aucun texte ni Liquid ici : les libellés arrivent par le bloc JSON [data-lpnv-i18n] de la section,
   la langue, la devise et les URL par les attributs data- de la racine.
   Fonctions : date de mise à jour localisée, prix HT/TTC (bascule du header), pourcentages localisés,
   teinte + quantité + ajout panier des cartes, tri natif, « Voir plus » par Section Rendering API. */
(function () {
  'use strict';
  var VAT = 1.2;

  function init(root) {
    if (!root || root.getAttribute('data-lpnv-init')) return;
    root.setAttribute('data-lpnv-init', '1');

    var LOC = root.getAttribute('data-locale') || 'fr';
    var CUR = root.getAttribute('data-currency') || 'EUR';
    var ROOT = root.getAttribute('data-root') || '/';
    if (ROOT.slice(-1) !== '/') ROOT += '/';
    var CART_URL = root.getAttribute('data-cart') || ROOT + 'cart';
    var SECTION = root.getAttribute('data-section');
    var L = {};
    try { L = JSON.parse(root.querySelector('[data-lpnv-i18n]').textContent); } catch (e) { L = {}; }

    /* Les clés _html peuvent contenir des entités : décodage pour textContent */
    var decEl = document.createElement('textarea');
    function dec(s) { decEl.innerHTML = s || ''; return decEl.value; }

    /* Date de mise à jour : « Mise à jour : novembre 2026 » dans la langue de la page */
    var edEl = root.querySelector('[data-lpnv-edition]');
    var edIso = root.getAttribute('data-edition');
    if (edEl && edIso && L.edition) {
      var d = new Date(edIso.length === 10 ? edIso + 'T12:00:00' : edIso);
      if (!isNaN(d.getTime())) {
        try {
          var m = new Intl.DateTimeFormat(LOC, { month: 'long', year: 'numeric' }).format(d);
          edEl.textContent = dec(L.edition).replace('%1', m);
        } catch (x) {}
      }
    }

    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (x) {}
    var hasIO = 'IntersectionObserver' in window;

    /* Apparition au défilement (désactivée si l'utilisateur réduit les animations) */
    var reveals = root.querySelectorAll('.lp-nouveautes__reveal');
    if (hasIO && !reduce) {
      root.classList.add('is-anim');
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { rio.observe(el); });
    }

    /* Compteurs animés : nombre formaté selon la langue */
    var intf = null;
    try { intf = new Intl.NumberFormat(LOC); } catch (x) {}
    function fmtN(n) { return intf ? intf.format(n) : String(n); }
    var counters = root.querySelectorAll('[data-lpnv-count]');
    counters.forEach(function (el) { var v = +el.getAttribute('data-lpnv-count'); if (!isNaN(v)) el.textContent = fmtN(v); });
    function runCount(el) {
      var v = +el.getAttribute('data-lpnv-count');
      if (isNaN(v) || v <= 0) return;
      var t0 = null, dur = 900;
      function step(ts) {
        if (!t0) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur);
        el.textContent = fmtN(Math.round(v * (1 - Math.pow(1 - k, 3))));
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (hasIO && !reduce && window.requestAnimationFrame) {
      var cio = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { runCount(en.target); cio.unobserve(en.target); } });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
    }

    /* Onglets des innovations : clic, flèches du clavier, ouverture par ancre */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-lpnv-tab]'));
    function openTab(i, focus) {
      var found = false;
      tabs.forEach(function (tb) {
        var on = tb.getAttribute('data-lpnv-tab') === String(i);
        if (on) found = true;
        tb.classList.toggle('is-on', on);
        tb.setAttribute('aria-selected', on ? 'true' : 'false');
        tb.tabIndex = on ? 0 : -1;
        var pn = document.getElementById(tb.getAttribute('aria-controls'));
        if (pn) { pn.hidden = !on; pn.classList.toggle('is-on', on); }
        if (on && focus) tb.focus();
      });
      if (found) paintPrices(root);
      return found;
    }
    tabs.forEach(function (tb, k) {
      tb.addEventListener('click', function () { openTab(tb.getAttribute('data-lpnv-tab')); });
      tb.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = tabs[(k + d + tabs.length) % tabs.length];
        openTab(n.getAttribute('data-lpnv-tab'), true);
      });
    });
    root.querySelectorAll('[data-lpnv-tab-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!openTab(a.getAttribute('data-lpnv-tab-link'))) return;
        var box = root.querySelector('[data-lpnv-tabs]');
        if (box) { e.preventDefault(); box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      });
    });
    var hm = (location.hash || '').match(/^#lp-nouveautes-inno-(\d+)$/);
    if (hm) openTab(hm[1]);

    /* Carrousels des gammes : flèches affichées seulement si la rangée déborde */
    root.querySelectorAll('[data-lpnv-scroller]').forEach(function (sc) {
      var track = sc.querySelector('[data-lpnv-track]'), nav = sc.querySelector('[data-lpnv-nav]');
      if (!track || !nav) return;
      function upd() { nav.hidden = track.scrollWidth <= track.clientWidth + 4; }
      upd();
      window.addEventListener('resize', upd);
      nav.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-lpnv-dir]');
        if (!b) return;
        track.scrollBy({ left: (+b.getAttribute('data-lpnv-dir')) * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    /* Pourcentages (badges, paliers) au format de la langue */
    var pf = null;
    try { pf = new Intl.NumberFormat(LOC, { style: 'percent', maximumFractionDigits: 1 }); } catch (x) {}
    function paintPct(scope) {
      if (!pf) return;
      scope.querySelectorAll('[data-lpnv-pct]').forEach(function (el) {
        var v = parseFloat(el.getAttribute('data-lpnv-pct'));
        if (!isNaN(v) && v > 0) el.textContent = pf.format(-v / 100);
      });
    }

    /* Prix HT/TTC : même lecture que le script du footer et silumen-remise-qte.js */
    function isHT() {
      try {
        var v = localStorage.getItem('taxToggleAll');
        if (v === 'true' || v === 'false') return v === 'false';
        return localStorage.getItem('tax_mode') === 'ht';
      } catch (e) { return false; }
    }
    var nf = null;
    try { nf = new Intl.NumberFormat(LOC, { style: 'currency', currency: CUR }); } catch (x) {}
    function paintPrices(scope) {
      if (!nf) return;
      var ht = isHT();
      (scope || root).querySelectorAll('[data-lpnv-price]').forEach(function (el) {
        var c = +el.getAttribute('data-lpnv-price');
        var amt = nf.format(Math.round(ht ? c / VAT : c) / 100);
        el.textContent = el.hasAttribute('data-lpnv-nolbl') ? amt : amt + ' ' + dec(ht ? L.ht : L.ttc);
      });
      (scope || root).querySelectorAll('[data-lpnv-tax]').forEach(function (el) { el.textContent = dec(ht ? L.ht : L.ttc); });
    }
    paintPct(root);
    paintPrices(root);
    document.addEventListener('change', function (e) { if (e.target && e.target.id === 'taxToggleAll') setTimeout(function () { paintPrices(root); }, 50); });
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('#stayTTC, #goHT')) setTimeout(function () { paintPrices(root); }, 50); });
    window.addEventListener('storage', function (e) { if (e.key === 'taxToggleAll' || e.key === 'tax_mode') paintPrices(root); });

    /* Toast */
    var toastEl = root.querySelector('[data-lpnv-toast]'), toastT;
    function toast(msg, href, linkTxt) {
      if (!toastEl) return;
      toastEl.textContent = dec(msg);
      if (href && linkTxt) {
        var a = document.createElement('a');
        a.href = href; a.textContent = dec(linkTxt);
        toastEl.appendChild(a);
      }
      toastEl.classList.add('is-on');
      clearTimeout(toastT);
      toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, href ? 4000 : 2400);
    }

    /* Cartes : quantité et ajout au panier */
    root.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-lpnv-qty]');
      if (q) {
        var qi = q.parentNode.querySelector('[data-lpnv-qty-input]');
        qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + (+q.getAttribute('data-lpnv-qty')));
        return;
      }
      var a = e.target.closest && e.target.closest('[data-lpnv-add]');
      if (!a || a.disabled) return;
      var card = a.closest('[data-lpnv-card]');
      var inp = card && card.querySelector('[data-lpnv-qty-input]');
      var qty = Math.max(1, parseInt(inp && inp.value, 10) || 1);
      var reset = function () { a.disabled = false; a.classList.remove('is-done', 'is-loading'); a.textContent = dec(L.add); };
      a.disabled = true; a.classList.add('is-loading'); a.textContent = dec(L.adding);
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +a.getAttribute('data-lpnv-add'), quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      }).then(function () {
        a.classList.remove('is-loading'); a.classList.add('is-done'); a.textContent = dec(L.done);
        toast(L.added, CART_URL, L.seeCart);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(reset, 1800);
      }).catch(function () { reset(); toast(L.addErr); });
    });

    /* Cartes : changement de teinte (prix, réf., badge, bouton) */
    root.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-lpnv-variant]');
      if (sel) {
        var o = sel.options[sel.selectedIndex], card = sel.closest('[data-lpnv-card]');
        var price = +o.getAttribute('data-price'), was = +o.getAttribute('data-was') || 0;
        var pc = was > price ? Math.round((was - price) / was * 100) : 0;
        var add = card.querySelector('[data-lpnv-add]'), now = card.querySelector('[data-lpnv-now]');
        var old = card.querySelector('[data-lpnv-was]'), off = card.querySelector('[data-lpnv-off]'), sku = card.querySelector('[data-lpnv-sku]');
        if (add) add.setAttribute('data-lpnv-add', o.value);
        if (now) now.setAttribute('data-lpnv-price', price);
        if (old) old.setAttribute('data-lpnv-price', was);
        var oldW = card.querySelector('[data-lpnv-was-w]');
        if (oldW) oldW.classList.toggle('is-none', !pc);
        if (off) {
          off.hidden = !pc;
          off.setAttribute('data-lpnv-pct', pc);
          if (pc) off.textContent = pf ? pf.format(-pc / 100) : '-' + pc + ' %';
        }
        if (sku) sku.textContent = o.getAttribute('data-sku') || '';
        var pick = sel.closest('[data-lpnv-pick]');
        if (pick) {
          pick.style.setProperty('--tone', o.getAttribute('data-tone') || '#d9dbd6');
          var pn = pick.querySelector('[data-pick-name]'), pk = pick.querySelector('[data-pick-k]');
          if (pn) pn.textContent = o.getAttribute('data-name') || o.textContent;
          if (pk) { pk.textContent = o.getAttribute('data-k') || ''; pk.hidden = !pk.textContent; }
        }
        paintPrices(card);
        return;
      }
      /* Tri natif Shopify : rechargement sur la grille */
      var so = e.target.closest && e.target.closest('[data-lpnv-sort]');
      if (so) {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', so.value);
        u.searchParams.delete('page');
        u.hash = 'lp-nouveautes-catalogue';
        window.location.href = u.toString();
      }
    });

    /* « Voir plus » : page suivante rendue par la section (Section Rendering API) */
    var grid = root.querySelector('[data-lpnv-grid]');
    var more = root.querySelector('[data-lpnv-more]');
    var pag = root.querySelector('[data-lpnv-pag]');
    var shownEl = root.querySelector('[data-lpnv-shown]');
    function updateShown() {
      if (!shownEl || !grid || !L.shown) return;
      var n = (+grid.getAttribute('data-offset') || 0) + grid.querySelectorAll('[data-lpnv-card]').length;
      var t = +grid.getAttribute('data-total') || n;
      var f = function (x) { try { return new Intl.NumberFormat(LOC).format(x); } catch (z) { return String(x); } };
      shownEl.textContent = dec(L.shown).replace('%1', f(n)).replace('%2', f(t));
    }
    updateShown();
    if (grid && more && SECTION && window.fetch && window.DOMParser) {
      more.hidden = false;
      if (pag) pag.hidden = true;
      var label = more.textContent;
      more.addEventListener('click', function () {
        var next = more.getAttribute('data-next');
        if (!next || more.disabled) return;
        more.disabled = true; more.textContent = dec(L.loading);
        var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(SECTION);
        fetch(url, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('page');
          return r.text();
        }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('[data-lpnv-grid] [data-lpnv-card]');
          var frag = document.createDocumentFragment();
          cards.forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
          var holder = document.createElement('div');
          holder.appendChild(frag);
          paintPct(holder);
          paintPrices(holder);
          while (holder.firstChild) grid.appendChild(holder.firstChild);
          var nMore = doc.querySelector('[data-lpnv-more]');
          var nNext = nMore && nMore.getAttribute('data-next');
          if (nNext) {
            more.setAttribute('data-next', nNext);
            more.disabled = false; more.textContent = label;
          } else {
            more.remove();
          }
          updateShown();
        }).catch(function () {
          /* Repli : la pagination classique reprend la main */
          more.remove();
          if (pag) pag.hidden = false;
        });
      });
    }
  }

  function boot() { document.querySelectorAll('[data-lpnv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
